import React, { useState } from "react";
import { PlayCircle } from "lucide-react";
import LogoImage from "../../img/logo.png";

// Importações das capas dos tutoriais
import modeloGemini from "../../img/tutorials/modelo GEMINI.png";
import macDownload from "../../img/tutorials/como baixar o ZapGPT no MAC.png";
import awsUpload from "../../img/tutorials/como colocar na AWS.png";
import vpsUpload from "../../img/tutorials/como colocar na VPS.png";
import configMessages from "../../img/tutorials/Configurações de mensagens.png";
import importarInstancia from "../../img/tutorials/importar instancia.png";
import windowsDownload from "../../img/tutorials/como baixar o ZapGPT no Windows.png";
import criarPrompt from "../../img/tutorials/como criar um prompt.png";
import criarInstancia from "../../img/tutorials/Criar instancia.png";
import googleCalendar from "../../img/tutorials/Google Calendar.png";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "../../components/ui/dialog";
import { tutorialModules, extractYoutubeId } from "../../shared/tutorials";
import { APP_NAME } from "../../config";

// Mapeamento das capas dos tutoriais por ID
const tutorialThumbnails = {
	1: modeloGemini,
	3: macDownload,
	4: awsUpload,
	5: vpsUpload,
	6: configMessages,
	7: importarInstancia,
	8: windowsDownload,
	9: criarPrompt,
	10: criarInstancia,
	11: googleCalendar,
};

export function Tutorial() {
	const [selectedVideo, setSelectedVideo] = useState(null);

	const openYouTubeVideo = (video) => {
		setSelectedVideo(video);
	};

	const closeDialog = () => {
		setSelectedVideo(null);
	};

	return (
		<div className="flex min-h-screen flex-col bg-slateBase py-8 px-4 text-whiteBase">
			<div className="w-full max-w-5xl mx-auto">
				<div className="mb-8">
					<h1 className="text-2xl font-bold text-textPrimary mb-2">
						Tutoriais em Vídeo
					</h1>
					<p className="text-textMuted">
						Aprenda a utilizar todos os recursos do {APP_NAME} através dos nossos
						vídeos tutoriais.
					</p>
				</div>

				{tutorialModules.map((module) => (
					<div key={module.id} className="mb-10">
						<h2 className="text-xl font-semibold text-textPrimary mb-4">
							{module.title}
						</h2>
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
							{module.videos.map((video) => (
								<button
									type="button"
									key={video.id}
									className="bg-slateCard/80 rounded-xl overflow-hidden border border-emeraldMedium/30 shadow-lg transition-all duration-300 hover:shadow-xl hover:border-emeraldMedium/50 cursor-pointer group text-left"
									onClick={() => openYouTubeVideo(video)}
									onKeyDown={(e) => {
										if (e.key === "Enter" || e.key === " ") {
											openYouTubeVideo(video);
										}
									}}
								>
									<div className="relative">
										<div className="aspect-video bg-slateContent/80 overflow-hidden relative">
											{/* Capa do tutorial */}
											<img
												src={tutorialThumbnails[video.id] || LogoImage}
												alt={video.title}
												className="w-full h-full object-cover object-center"
											/>
											<div className="absolute inset-0 bg-gradient-to-t from-blackBase/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
											<div className="absolute bottom-2 right-2 bg-blackBase/70 text-whiteBase text-xs px-2 py-1 rounded-md">
												{video.duration}
											</div>
											<div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
												<PlayCircle className="w-16 h-16 text-emeraldLight drop-shadow-lg" />
											</div>
										</div>
									</div>
									<div className="p-4">
										<h3 className="text-textPrimary font-semibold line-clamp-2 mb-1">
											{video.title}
										</h3>
									</div>
								</button>
							))}
						</div>
					</div>
				))}
			</div>

			<Dialog
				open={!!selectedVideo}
				onOpenChange={(open) => !open && closeDialog()}
			>
				<DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-y-auto bg-slateCard/95 border-emeraldMedium/30">
					<DialogHeader>
						<DialogTitle className="text-textPrimary">{selectedVideo?.title}</DialogTitle>
					</DialogHeader>
					{selectedVideo && (
						<div className="aspect-video w-full">
							<iframe
								width="100%"
								height="100%"
								src={`https://www.youtube.com/embed/${extractYoutubeId(selectedVideo.url)}`}
								title={selectedVideo.title}
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
								className="rounded-md"
							/>
						</div>
					)}
				</DialogContent>
			</Dialog>
		</div>
	);
}
